<template>
  <div 
    class="--month-control"
    >
    <div 
      v-for="(_month, index) in _months"
      class="--month-control__item"
      :class="{
        'active': _monthCurrent === (index+1),
      }"
      @click="onChange(index+1)"
      >
      {{ _month }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
const emit = defineEmits(['onChange'])

const _months = ref([
  'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
  'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
]);

const _monthCurrent = ref(0)

const props = defineProps({
  month: {
    type: Number,
    default: 0
  },
})

const onChange = (month) => {
  _monthCurrent.value = month
  emit('onChange', month)
}

onMounted(() => {
  _monthCurrent.value = props.month
})

</script>

<style scoped >
.--month-control {
  overflow: hidden;
  display: grid;
  grid-template-columns:  repeat(12, 1fr);
  align-items: center;
  gap: 8px;
  padding: 0px;
  .--month-control__item {
    padding: 8px;
    text-align: center;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s;
    &:hover {
      background-color: #f0f0f0;
    }
    &.active {
      background-color: #0069F0;
      color: #fff;
    }
  }
  
}
</style>